<template>
  <div v-if="flight.seatmap" 
    :class="`legend ${mobileLegendOnTop ? 'legend-on-top' : ''}  ${flight.seatmap == null ? 'legend-seatmap-not-available' : ''}`"
    :style="{
      '--passengerSelectedColor': style.passengerSelectedColor,
      '--passengerSelectedFontColor': style.passengerSelectedFontColor,
      '--seatSelectedColor': style.seatSelectedColor,
      '--seatOccupiedColor': style.seatOccupiedColor,
      '--seatAvailable0Color': style.seatAvailable0Color,
      '--seatAvailable1Color': style.seatAvailable1Color,
      '--seatAvailable2Color': style.seatAvailable2Color,
      '--fontFamily': style.fontFamily,
      '--fontColor1': style.fontColor1,
      '--fontColor2': style.fontColor2,
      '--fontColor3': style.fontColor3,
    }"
  >

  <div  v-if="flight.seatmap">
    <h6>{{ text.seat_information }}</h6>

  </div>

    <div class="legend--item-container" v-if="flight.seatmap">
      <div
        class="legend--single-item"
        v-for="(price, index) in priceMap"
        :key="`price_${index}`"
        :style="{
          '--seatAvailableColor': price.color,
        }"
      >
        <div
          class="seat"
          :class="`${
            price.hasOwnProperty('color')
              ? 'seat-available'
              : 'group-' + price.group
          } ${
            price.hasOwnProperty('meta') && price.meta.extraLeg
              ? 'extraleg'
              : ''
          }`"
        >
          <div class="seat-border"></div>
        </div>
        <div class="info">
          <strong>{{ price.label }} </strong>
          <span v-if="locale == 'he' ||  locale == 'ar'">
            <span
              > • {{ text.from }} <b>{{ formatCurrency(price.price) }}</b>
              {{ text.price_at_person }}</span
            >
          </span>
          <span v-else>
            • {{ text.from }} <b>{{ formatCurrency(price.price) }}</b> {{ text.price_at_person }} 
          
          </span>
          <span v-if="price.description && price.description.length > 0">• {{
            price.description
          }}</span>
        </div>
        
      </div>

<div class="info">
  <span v-if="locale == 'de' && (flight.airline =='FR' ||  flight.airline == 'W6')">
    {{ text.post_sale_price }}
  </span>
</div>
      <div class="legend--spacer"></div>
      <div class="legend--single-item">
        <div class="seat occupied">
          <div class="seat-border"></div>
        </div>
        <div class="info">
          <strong>{{ text.booked }}</strong>
        </div>
      </div>
      <div class="legend--single-item">
        <div class="seat selected-for-this-passenger">
          <div class="seat-border"></div>
        </div>
        <div class="info">
          <strong>{{ text.selected }}</strong>
        </div>
      </div>
    </div>

    <!--<div class="legend&#45;&#45;single-item">
      <a href="#" @click.prevent="handleRandomChoice">{{ text.select_automatically }}</a>
    </div>-->
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  methods: {
    handleRandomChoice() {
      this.selectSeatsAutomatically();
    },

    ...mapActions(["selectSeatsAutomatically"]),
  },
  computed: {
    ...mapGetters(["style", "text", "priceMap", "formatCurrency", "locale", "flight"]),
    ...mapState(["mobileLegendOnTop"]),
  },
};
</script>
<style>

#seat-selector-container *{
    box-sizing: unset;
}
#ss-container .legend {
  position: -webkit-sticky;
  position: sticky;
  top: 100px;
  width: 100%;
  max-width: calc(280px - 2rem);
  margin: 0 auto 100px;
  padding: 1rem;
  color: var(--fontColor2);
}

#ss-container .legend h6 {
  font-size: 18px;
  margin: 0;
  margin-bottom: 20px;
  font-family: var(--fontFamily);
}
#ss-container .legend--single-item {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-align-items: center;
  align-items: center;
  justify-content: flex-start;
  margin: 10px 0 20px;
}
#ss-container .legend--single-item a {
  height: 40px;
  width: 100%;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-align-items: center;
  align-items: center;
  justify-content: center;
  font-family: var(--fontFamily);
  text-decoration: none;
  color: var(--passengerSelectedColor);
  border: 1px solid var(--passengerSelectedColor);
  border-radius: 2px;
  text-transform: uppercase;
  font-size: 13px;
  margin-top: 1rem;
}
#ss-container .legend--single-item a:hover {
  color: var(--passengerSelectedFontColor);
  background-color: var(--passengerSelectedColor);
}
#ss-container .legend--single-item .seat {
  margin-left: 0;
  margin-right: 15px;
  min-width: 36px;
}
#ss-container .legend--single-item .info {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-align-items: flex-start;
  align-items: flex-start;
  justify-content: flex-start;
  -webkit-flex-direction: column;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  -o-flex-direction: column;
  flex-direction: column;
  font-size: 16px;
  font-family: var(--fontFamily);
}
#ss-container .legend--single-item .info span {
  margin-top: 5px;
  font-size: 12px;
  color: var(--fontColor3);
}
#ss-container .legend--spacer {
  margin-top: 45px;
}
@media (max-width: 768px) {
  #ss-container .legend-on-top {
    max-width: 100%;
    position: relative;
    top: 100px;
  }
  #ss-container .legend-on-top h6 {
    margin-bottom: 10px;
  }
  #ss-container .legend-on-top .legend--single-item {
    margin-bottom: 5px;
    width: 50%;
  }
  #ss-container .legend-on-top .legend--spacer {
    margin-top: 5px;
  }
  #ss-container .legend-on-top .legend--item-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  #ss-container .legend-on-top h6 {
    font-size: 16px;
    text-align: center;
  }
  #ss-container .legend-on-top .legend--single-item .info {
    font-size: 12px;
  }
  #ss-container .legend-on-top .legend--single-item .info span {
    font-size: 11px;
  }
}
/*Medium devices (tablets, 768px and up)*/
@media (min-width: 768px) {
  #ss-container .legend {
    float: left;
    margin-top: 130px;
    margin-left: 80px;
    max-width: calc(305px - 2rem);
  }
  #ss-container .legend-on-top {
    float: right;
  }
}
/*Large devices (desktops, 992px and up)*/
@media (min-width: 992px) {
  #ss-container .legend {
    max-width: calc(280px - 2rem);
  }
}
/*Extra large devices (large desktops, 1200px and up)*/
@media (min-width: 1200px) {
  #ss-container .legend {
    max-width: calc(280px - 2rem);
  }
}

.info span {
      margin-top: 5px;
    font-size: 12px;
    color: var(--fontColor3);
}

.seatmap-not-available-title{
  text-align: center;
  margin-bottom: 10px !important;
  font-family: "Open Sans", Arial, Helvetica, sans-serif;
}

.seatmap-not-available-info{
  text-align: center;
  letter-spacing: 0px;
  color: #858585;
  opacity: 1;
  margin-top:0px;
  font-family: "Open Sans", Arial, Helvetica, sans-serif;
}
/* @media (min-width: 768px) {
  .seatmap-not-available {
    margin-left: 200px !important;
    white-space: nowrap;
  }
} */
</style>



// WEBPACK FOOTER //
// src/components/Legend.vue